import React from 'react';
import { Modal, Button, Textarea } from 'flowbite-react';

const NoteModal = ({ 
  showNoteModal, 
  setShowNoteModal, 
  noteText, 
  setNoteText, 
  handleSaveNote,
  isDarkMode = false,
  verseKey = ''
}) => {
  return (
    <Modal 
      show={showNoteModal} 
      onClose={() => setShowNoteModal(false)}
      className={isDarkMode ? 'dark' : ''}
      theme={{
        root: {
          base: "h-full flex items-end md:items-center justify-center overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          show: {
            on: "flex bg-gray-900/60 dark:bg-gray-900/80",
            off: "hidden"
          }
        },
        content: {
          base: "relative h-full w-full p-4 md:h-auto",
          inner: "relative rounded-lg bg-white dark:bg-gray-800 shadow flex flex-col max-h-[90vh]"
        }
      }}
    >
      <Modal.Header className={`border-b ${isDarkMode ? 'border-gray-700 text-white' : 'border-gray-200'}`}>
        {verseKey ? `Add Note for Verse ${verseKey}` : 'Add Note'}
      </Modal.Header>
      <Modal.Body>
        <Textarea
          placeholder="Enter your note..."
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          className="w-full"
          rows={5}
        />
      </Modal.Body>
      <Modal.Footer className={isDarkMode ? 'border-gray-700' : ''}>
        <Button onClick={handleSaveNote} color="success">Save Note</Button>
        <Button color="gray" onClick={() => setShowNoteModal(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NoteModal;
